import { render, staticRenderFns } from "./postCounters.vue?vue&type=template&id=41035f9a&scoped=true&"
import script from "./postCounters.vue?vue&type=script&lang=js&"
export * from "./postCounters.vue?vue&type=script&lang=js&"
import style0 from "./postCounters.vue?vue&type=style&index=0&id=41035f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41035f9a",
  null
  
)

export default component.exports